import { motion } from 'framer-motion'

export const FutureLoader = ({ className, innerClassName }) => {
    return (
        <div className={`flex items-center justify-center ${className}`}>
            <div className={`relative w-20 h-20 ${innerClassName}`}>
                <motion.div
                    className="absolute inset-0 rounded-full bg-primary-300/40 backdrop-blur-sm"
                    animate={{
                        boxShadow: [
                            "0 0 20px 10px rgba(240, 128, 128, 0.3)",
                            "0 0 40px 20px rgba(240, 128, 128, 0.3)",
                            "0 0 20px 10px rgba(240, 128, 128, 0.3)",
                        ],
                    }}
                    transition={{
                        duration: 1.5,
                        repeat: Number.POSITIVE_INFINITY,
                        ease: "easeInOut",
                    }}
                />
                <motion.div
                    className="absolute top-1/2 left-1/2 w-20 h-20 rounded-full bg-primary opacity-50 blur-md"
                    animate={{
                        scale: [1, 1.3, 1],
                        x: ["-50%", "-30%", "-70%", "-50%"],
                        y: ["-50%", "-70%", "-30%", "-50%"],
                    }}
                    transition={{
                        duration: 4,
                        repeat: Number.POSITIVE_INFINITY,
                        ease: "easeInOut",
                    }}
                />
                <motion.div
                    className="absolute top-1/2 left-1/2 w-20 h-20 rounded-full bg-background opacity-30 blur-sm"
                    animate={{
                        scale: [1, 1.2, 1],
                        x: ["-50%", "-60%", "-40%", "-50%"],
                        y: ["-50%", "-40%", "-60%", "-50%"],
                    }}
                    transition={{
                        duration: 3,
                        repeat: Number.POSITIVE_INFINITY,
                        ease: "easeInOut",
                        delay: 0.5,
                    }}
                />
            </div>
        </div>
    )
}
